var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarchart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 78.59 80.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3865ab;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.72,
    y1: 68.76,
    x2: 15.43,
    y2: 49.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2cc0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 45.26,
    y1: 68.7,
    x2: 44.55,
    y2: 24.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 73.92,
    y1: 67.1,
    x2: 74.48,
    y2: 8.07,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 33.91,
    width: 8.74,
    height: 38.3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.31,
    y: 39.5,
    width: 8.74,
    height: 32.72,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 76.42,
    width: 78.59,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.62,
    y: 9.13,
    width: 8.74,
    height: 63.08,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.22,
    y: 48,
    width: 8.74,
    height: 24.21,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40.53,
    y: 20.1,
    width: 8.74,
    height: 52.12,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.84,
    width: 8.74,
    height: 72.21,
    rx: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarchart);
export default __webpack_public_path__ + "static/media/barchart.188caa920d66fdb02c6f43a836429ac5.svg";
export { ForwardRef as ReactComponent };